import http from '../common/http'
// 提交质保
export const addQualityAssurance = qualityAssurance => (
	http.post('/QualityAssurance/QualityAssuranceAdd', qualityAssurance)
)
//质保列表
export const qualityAssuranceList = recordInput => (
	http.post('/QualityAssurance/GetQualityAssuranceList', recordInput)
)
//质保查询结果
export const qualityAssuranceResult = recordInput => (
	http.post('/QualityAssurance/GetQualityAssuranceResult', recordInput)
)
//质保详情
export const qualityAssuranceDetail = recordid => (
	http.get('/QualityAssurance/GetQualityAssuranceDetail',  { recordid: recordid })
)
//提交售后
export const handleAfterSales = afterSaleInput => (
	http.post('/QualityAssurance/SubmitAfterSale',  afterSaleInput)
)
//取消售后
export const cancelAfterSale = afterSaleInput => (
	http.post('/QualityAssurance/CancelAfterSale',  afterSaleInput)
)
// 获取质保网点门店列表
export const getStoreList = () =>(
	http.get('/Store/GetQualityAssuranceStoreList')
)
//是否自营商家
export const isSelfSupport = () => (
	http.post('/QualityAssurance/IsSelfSupport')
);

//是否显示门店出货下单入口
export const showStoreSellEntry = () => (
	http.post('/QualityAssurance/IsShowStoreSellEntry')
);

export const verifyOneCode = oneCode =>(
	http.get('/QualityAssurance/VerifyOneCode',  { oneCode: oneCode })
)



// WEBPACK FOOTER //
// ./src/api/qualityAssuranceApi.js